import { render, staticRenderFns } from "./VariantTableHeaderCell.vue?vue&type=template&id=764de9bb&"
import script from "./VariantTableHeaderCell.ts?vue&type=script&lang=ts&"
export * from "./VariantTableHeaderCell.ts?vue&type=script&lang=ts&"
import style0 from "./VariantTableHeaderCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTh,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTh,QTooltip})
